(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/utils/api-calls.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/utils/api-calls.js');
"use strict";


const searchPath = query => "".concat(svs.lyckoplatsen.data.config.apiLocation, "/v1/search?query=").concat(query);
const idPath = id => "".concat(svs.lyckoplatsen.data.config.apiLocation, "/v1/geocode?id=").concat(id);
setGlobal('svs.lyckoplatsen.components.page_play.utils', {
  fetchGeolocationSearch: async query => {
    const data = await fetch(searchPath(query), {
      headers: {
        'x-jwt-token': "".concat(svs.lyckoplatsen.data.config.jwt)
      }
    });
    const json = await data.json();
    return json;
  },
  fetchGeolocationCoordinates: async id => {
    const data = await fetch(idPath(id), {
      headers: {
        'x-jwt-token': "".concat(svs.lyckoplatsen.data.config.jwt)
      }
    });
    const json = await data.json();
    return json;
  }
});

 })(window);